import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import NewDashboard from './components/NewDashboard';
import NewAssistant from './components/NewAssistant';
import EditAssistant from './components/EditAssistant';
import MyAssistants from './components/MyAssistants';
import NewGptAssistant from './components/NewGptAssistant';
import EditGptAssistant from './components/EditGptAssistant';
import MyGptAssistants from './components/MyGptAssistants';
import Reports from './components/Reports';
import SelectRegional from './components/SelectRegional';
import SelectAccessContext from './components/SelectAccessContext';
import AdminSelectRegional from './components/AdminSelectRegional';
import AdminMonitor from './components/AdminMonitor';
import AdminDashboard from './components/AdminDashboard';
import AdminCreateProfesor from './components/AdminCreateProfesor';
import AdminEditProfesor from './components/AdminEditProfesor';
import AdminCreateAlumno from './components/AdminCreateAlumno';
import AdminEditAlumno from './components/AdminEditAlumno';
import AdminCreateAdminArea from './components/AdminCreateAdminArea';
import AdminEditAdminArea from './components/AdminEditAdminArea';
import AdminCreateRegional from './components/AdminCreateRegional';
import AdminCreateRegionalAdmin from './components/AdminCreateRegionalAdmin';
import AdminEditRegional from './components/AdminEditRegional';
import AdminCreateMateria from './components/AdminCreateMateria';
import AdminEditMateria from './components/AdminEditMateria';
import AdminCreateArea from './components/AdminCreateArea';
import AdminEditArea from './components/AdminEditArea';
import AdminCreateAsistente from './components/AdminCreateAsistente';
import AdminEditAsistente from './components/AdminEditAsistente';
import SolicitudesProcesos from './components/SolicitudesProcesos';
import Procesos from './components/Procesos';
import SubjectCardsGrid from './components/SubjectCardsGrid';
import CambiarContrasena from './components/CambiarContrasena';
import AveChainlitChat from './components/AveChainlitChat';
import TestAve from './components/TestAve';
import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <Routes>
            {/* Ruta pública de login */}
            <Route path="/login" element={<Login />} />

            {/* Ruta pública de asistentes */}
            <Route path="/" element={<SubjectCardsGrid />} />
            <Route path="/chat" element={<SubjectCardsGrid />} />
            <Route path="/testAve" element={<TestAve />} />
            <Route path="/ave-chat" element={<AveChainlitChat />} />
            
            {/* Rutas protegidas */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <NewDashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/new-assistant" element={
              <ProtectedRoute>
                <NewAssistant />
              </ProtectedRoute>
            } />

            <Route path="/new-ragflow-assistant" element={
              <ProtectedRoute>
                <NewAssistant provider="ragflow" />
              </ProtectedRoute>
            } />
            
            <Route path="/my-assistants" element={
              <ProtectedRoute>
                <MyAssistants />
              </ProtectedRoute>
            } />

            <Route path="/ragflow-assistants" element={
              <ProtectedRoute>
                <MyAssistants provider="ragflow" />
              </ProtectedRoute>
            } />

            <Route path="/new-gpt-assistant" element={
              <ProtectedRoute>
                <NewGptAssistant />
              </ProtectedRoute>
            } />

            <Route path="/gpt-assistants" element={
              <ProtectedRoute>
                <MyGptAssistants />
              </ProtectedRoute>
            } />

            <Route path="/gpt-assistants/:assistantId/edit" element={
              <ProtectedRoute>
                <EditGptAssistant />
              </ProtectedRoute>
            } />
            
            <Route path="/assistants/:assistantId/edit" element={
              <ProtectedRoute>
                <EditAssistant />
              </ProtectedRoute>
            } />

            <Route path="/ragflow-assistants/:assistantId/edit" element={
              <ProtectedRoute>
                <EditAssistant provider="ragflow" />
              </ProtectedRoute>
            } />

            <Route path="/select-regional" element={
              <ProtectedRoute>
                <SelectRegional />
              </ProtectedRoute>
            } />

            <Route path="/select-access-context" element={
              <ProtectedRoute>
                <SelectAccessContext />
              </ProtectedRoute>
            } />
            
            <Route path="/reports" element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            } />

            <Route path="/procesos" element={
              <ProtectedRoute>
                <Procesos />
              </ProtectedRoute>
            } />

            <Route path="/admin/select-regional" element={
              <ProtectedRoute>
                <AdminSelectRegional />
              </ProtectedRoute>
            } />

            <Route path="/admin/monitor" element={
              <ProtectedRoute>
                <AdminMonitor />
              </ProtectedRoute>
            } />

            <Route path="/admin-dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            <Route path="/admin/profesores/nuevo" element={
              <ProtectedRoute>
                <AdminCreateProfesor />
              </ProtectedRoute>
            } />

            <Route path="/admin/profesores/:profesorId/editar" element={
              <ProtectedRoute>
                <AdminEditProfesor />
              </ProtectedRoute>
            } />

            <Route path="/admin/alumnos/nuevo" element={
              <ProtectedRoute>
                <AdminCreateAlumno />
              </ProtectedRoute>
            } />

            <Route path="/admin/alumnos/:alumnoId/editar" element={
              <ProtectedRoute>
                <AdminEditAlumno />
              </ProtectedRoute>
            } />

            <Route path="/admin/admin-area/nuevo" element={
              <ProtectedRoute>
                <AdminCreateAdminArea />
              </ProtectedRoute>
            } />

            <Route path="/admin/admin-area/:adminAreaId/editar" element={
              <ProtectedRoute>
                <AdminEditAdminArea />
              </ProtectedRoute>
            } />

            <Route path="/admin/regionales/nuevo" element={
              <ProtectedRoute>
                <AdminCreateRegional />
              </ProtectedRoute>
            } />

            <Route path="/admin/regionales/:regionalId/admins/nuevo" element={
              <ProtectedRoute>
                <AdminCreateRegionalAdmin />
              </ProtectedRoute>
            } />

            <Route path="/admin/regionales/:regionalId/editar" element={
              <ProtectedRoute>
                <AdminEditRegional />
              </ProtectedRoute>
            } />

            <Route path="/admin/materias/nuevo" element={
              <ProtectedRoute>
                <AdminCreateMateria />
              </ProtectedRoute>
            } />

            <Route path="/admin/materias/:materiaId/editar" element={
              <ProtectedRoute>
                <AdminEditMateria />
              </ProtectedRoute>
            } />

            <Route path="/admin/areas/nuevo" element={
              <ProtectedRoute>
                <AdminCreateArea />
              </ProtectedRoute>
            } />

            <Route path="/admin/areas/:areaId/editar" element={
              <ProtectedRoute>
                <AdminEditArea />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/asistentes/nuevo" element={
              <ProtectedRoute>
                <AdminCreateAsistente />
              </ProtectedRoute>
            } />

            <Route path="/admin/asistentes-ragflow/nuevo" element={
              <ProtectedRoute>
                <AdminCreateAsistente provider="ragflow" />
              </ProtectedRoute>
            } />

            <Route path="/admin/asistentes/:assistantId/editar" element={
              <ProtectedRoute>
                <AdminEditAsistente />
              </ProtectedRoute>
            } />

            <Route path="/admin/asistentes-ragflow/:assistantId/editar" element={
              <ProtectedRoute>
                <AdminEditAsistente provider="ragflow" />
              </ProtectedRoute>
            } />
            
            <Route path="/admin/solicitudes-procesos" element={
              <ProtectedRoute>
                <SolicitudesProcesos />
              </ProtectedRoute>
            } />

            <Route path="/cambiar-contrasena" element={
              <ProtectedRoute>
                <CambiarContrasena />
              </ProtectedRoute>
            } />

            {/* Ruta de fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
